import { TEST_CONFIG } from 'js/ab_tests/tests/nav_impact_stats_2026_q3_v1';

import { ARMS } from './arms/index';

export type Arm =
  | 'control'
  | 'v1_delta_chips'
  | 'v2_plain_counts_stacked'
  | 'v3_plain_counts_inline'
  | 'v4_trend_icons';

export type ResolvedArm = Arm | undefined;

export type StatStyle = 'none' | 'plain' | 'delta_chip' | 'trend_icon';
export type StatLayout = 'stacked' | 'inline';

export interface NavImpactSurfaces {
  statStyle: StatStyle;
  statLayout: StatLayout;
}

export const CONTROL: NavImpactSurfaces = {
  statStyle: 'none',
  statLayout: 'stacked',
};

export function resolveNavImpactStats(
  arm: string | null | undefined,
): NavImpactSurfaces {
  const spec = arm == null ? undefined : ARMS[arm as Arm];
  return { ...CONTROL, ...(spec ? spec() : {}) };
}

export function impressionExtra(
  arm: string | null | undefined,
): Record<string, unknown> {
  const isActive: boolean = TEST_CONFIG.active as boolean;
  return {
    test_bucket: arm ?? 'control',
    ...(isActive && { test_name: 'nav_impact_stats_2026_q3_v1' }),
  };
}
